export function normalizePostUpsellChoiceGroup(group) {
  if (Array.isArray(group)) {
    return { orderPageItemId: null, choices: group };
  }

  return {
    orderPageItemId: group?.orderPageItemId ?? null,
    choices: Array.isArray(group?.choices) ? group.choices : [],
  };
}
